import type {
  ApiLanguage, CachedLangData, LangPack, LangPackStringValuePlural,
} from '../../api/types';

import readStrings from './readStrings';

const FALLBACK_LANG_CODE = 'en';
const FALLBACK_VERSION = 0;
const FALLBACK_TRANSLATE_URL = 'https://translations.telegram.org/en/weba';

export default async function readFallbackStrings(forLocalScript?: boolean): Promise<CachedLangData> {
  let fileData;
  if (forLocalScript) {
    fileData = (await import('fs')).readFileSync('./src/assets/localization/fallback.strings', 'utf8');
  } else {
    const file = await import('../../assets/localization/fallback.strings');
    fileData = file.default;
  }
  const rawStrings = readStrings(fileData);

  const strings: LangPack['strings'] = {};

  const PLURAL_SUFFIXES = new Set(['zero', 'one', 'two', 'few', 'many', 'other']);

  Object.entries(rawStrings).forEach(([key, value]) => {
    const lastUnderscore = key.lastIndexOf('_');
    const possibleSuffix = lastUnderscore > 0 ? key.slice(lastUnderscore + 1) : undefined;
    const isPluralKey = possibleSuffix && PLURAL_SUFFIXES.has(possibleSuffix);

    if (!isPluralKey) {
      strings[key] = value;
      return;
    }

    const clearKey = key.slice(0, lastUnderscore);
    const knownValue = (strings[clearKey] || {}) as LangPackStringValuePlural;
    knownValue[possibleSuffix as keyof LangPackStringValuePlural] = value;
    strings[clearKey] = knownValue;
  });

  const langPack: LangPack = {
    langCode: FALLBACK_LANG_CODE,
    version: FALLBACK_VERSION,
    strings,
  };

  const stringsCount = Object.keys(strings).length;

  const language: ApiLanguage = {
    langCode: FALLBACK_LANG_CODE,
    name: 'English',
    nativeName: 'English',
    pluralCode: FALLBACK_LANG_CODE,
    stringsCount,
    translatedCount: stringsCount,
    translationsUrl: FALLBACK_TRANSLATE_URL,
  };

  return {
    langPack,
    language,
  };
}
